import { withAuthenticationRequired } from '@tom-ui/utils'
import { messageBus, useBillingServiceStore } from '@billing/AppProvider'
import { CatalogueDialogContainer } from '@billing/features/commodity/containers/CatalogueDialogContainer'
import { CommoditiesAndPackagingContainer } from '@billing/features/commodity/containers/CommoditiesAndPackagingContainer'
import { CommoditiesDialogContainer } from '@billing/features/commodity/containers/CommoditiesDialogContainer'
import { CommodityFilterUIStore } from '@billing/features/commodity/stores/commodity-filter.ui-store'
import { CommodityListUIStore } from '@billing/features/commodity/stores/commodity-list.ui-store'
import { PackagesDialogContainer } from '@billing/features/packaging/containers/PackagesDialogContainer'
import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

const CommoditiesAndPackaging: FC = withAuthenticationRequired(() => {
  const { t } = useTranslate()
  const { commodityStore, catalogueStore } = useBillingServiceStore()
  const theme = useMinimalsTheme()

  const commodityFilterUIStore = useMemo(() => new CommodityFilterUIStore(), [])

  const commoditiesListStore = useMemo(
    () =>
      new CommodityListUIStore(commodityStore, catalogueStore, commodityFilterUIStore, messageBus),
    [commodityStore, commodityFilterUIStore],
  )

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        minHeight: '100%',
      }}
    >
      <Helmet>
        <title>
          {t(
            'commoditiesAndPackagingTomBillingService',
            'Commodities & Packaging - TOM Billing Service',
          )}
        </title>
      </Helmet>

      <CommoditiesAndPackagingContainer
        commoditiesListStore={commoditiesListStore}
        commodityFilterStore={commodityFilterUIStore}
      />
      <CommoditiesDialogContainer />
      <CatalogueDialogContainer />
      <PackagesDialogContainer />
    </Box>
  )
})

export default CommoditiesAndPackaging
